import { coerce } from './coerceForTable';
import type { DateRange } from '@repo/types/Types';

export function combineDateRange(
  start: Date | undefined,
  end: Date | undefined
): DateRange | undefined {
  const startDate = coerce(start);
  const endDate = coerce(end);
  if (startDate) {
    if (endDate) {
      return {
        range: {
          start: {
            value: startDate,
          },
          end: {
            value: endDate,
          },
        },
      };
    }

    return {
      range: {
        start: {
          value: startDate,
        },
        end: {
          is_infinity: true,
        },
      },
    };
  }

  if (endDate) {
    return {
      range: {
        start: {
          is_infinity: true,
        },
        end: {
          value: endDate,
        },
      },
    };
  }
}
